<template>
  <div class="container">
    <div class="meet-level trans">
      <meet-header
        :headerConfig="headerConfig"
        @handleClickIocn="handleClickIocn"
      />

      <div class="main">
        <h2 class="tit">{{ schedule.name }}</h2>
        <div class="level-item shadow">
          <h2 class="dl-tit">会议日程？</h2>
          <RichHtml
            style="margin-left: 4px; margin-right: 4px"
            :content="this.schedule.introduction"
          ></RichHtml>
        </div>
        <!-- <div class="level-item shadow">
                    <h2 class="dl-tit">地图</h2>
                    <div class="group">
                     
                    </div>
                </div> -->
      </div>
    </div>
  </div>
</template>

<script>
  import meetHeader from "@/components/header"
  import RichHtml from "@/components/RichHtml"

  export default {
    name: "meetLevel",
    components: {
      meetHeader,
      RichHtml,
    },
    data() {
      return {
        headerConfig: {
          headerIcon: "city ct-xiangyou",
          headerTitle: "会议日程",
        },
        schedule: {},
      }
    },
    created() {
      this.schedule = this.$route.params.schedule
    },
    methods: {
      handleClickIocn() {
        history.go(-1)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .main {
    width: 100%;
    padding: 0 15px;
    margin-bottom: 30px;
    box-sizing: border-box;

    .tit {
      padding-left: 8px;
      margin-top: 30px;
      border-left: 4px solid var(--main-color);
      font-size: 18px;
      font-weight: bold;
      color: var(--main-color);
    }
    .level-item {
      padding: 15px;
      box-sizing: border-box;
      background: #fff;
      border-radius: 5px;
      margin-top: 25px;

      .dl-tit {
        font-size: 16px;
        color: var(--main-color);
      }

      .group {
        text-align: center;
        margin-top: 10px;
      }

      .tips {
        font-size: 14px;
        color: #666;
        line-height: 30px;
      }
    }
  }
</style>
